<template>
    <div class="row">
        <div class="col-12">
            <div :class="'text-center' + (datos_online.qr_codes.length > 0 ? ' mb-3' : '')">
                <p class="h4 mb-3 px-2" v-if="datos_online.puede_descargar_entradas">
                    {{ $t(datos_online.qr_codes.length > 0 ?
                        (!reserva_instalaciones ? "gracias.descargar_entradas" : "gracias.descargar_reservas") : 
                        "gracias.descargar_productos")
                    }}
                </p>
                <p class="h4 mb-3 px-2" v-else>
                    ¡Compra confirmada!
                </p>
                <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center px-2">
                    <p class="mr-sm-2 mt-1 mb-2 mb-sm-0">
                        {{ $t("gracias.n_pedido") }}:
                    </p>
                    <h4 id="n-pedido" data-cy="n-pedido" class="mb-0">
                        {{ tpv_order }}
                    </h4>
                </div>
            </div>

            <div class="text-center buttons mb-3 px-2" v-if="datos_online.qr_codes.length">
                <a
                    :href="datos_online.url_descarga"
                    class="button large-button effect-button mr-0 mr-lg-2 mb-2 d-block d-sm-inline-block"
                    target="_blank"
                    v-if="datos_online.puede_descargar_entradas"
                >
                    <span style="text-transform: uppercase">
                        {{ !reserva_instalaciones ? $t("gracias.descargar_pdf_completo") : $t('gracias.descargar_pdf_completo_reservas') }}
                    </span>
                </a>
                <router-link 
                    tag="a" 
                    :to="{ name: 'front.home' }"
                    class="button large-button effect-button mr-0 mr-lg-2 mb-2 d-block d-sm-inline-block"
                >
                    <span>{{ $t("gracias.volver") }}</span>
                </router-link>
            </div>
            <div class="d-flex flex-column flex-md-row justify-content-between px-2">
                <div class="h5 h4-md mb-2 mb-md-3" v-if="datos_compradores.length">
                    {{ $t('gracias.fecha') }}: {{ sesion_fecha }}
                </div>
                <div class="h5 h4-md mb-2 mb-md-3" v-if="datos_online.nombre_evento">
                    {{ $t('gracias.evento') }}: {{ datos_online.nombre_evento }}
                </div>
            </div>
            <div class="h6 h5-md mb-3 px-2" v-if="datos_compradores[0]?.visibilidad_reducida">
                <span v-if="datos_compradores.length > 1">{{ $t("gracias.entradas_vision_reducida") }}</span>
                <span v-else>{{ $t("gracias.entrada_vision_reducida") }}</span>
            </div>

            <div class="px-2">
                <TarjetaEntrada
                    v-for="(datos_comprador, i) in datos_compradores"
                    v-bind:key="i"
                    :entrada="datos_comprador"
                    :index="i"
                    :reserva_instalaciones="reserva_instalaciones"
                    :puede_descargar_entradas="datos_online.puede_descargar_entradas"
                />
                <template v-if="productos.length > 0">
                    <b-row class="pt-3 justify-content-between mx-0">
                        <b-col cols="12" sm="6" md="4" class="px-0 px-sm-2">
                            <div class="h5 h4-md my-3">{{ $t("gracias.productos") }}</div>
                        </b-col>
                        <b-col cols="12" sm="6" md="8" class="text-center text-sm-right px-0 px-sm-2">
                            <a
                                :href="getUrlPdfProducts(productos[0].qr_code)"
                                class="button large-button effect-button mr-0 mb-2 d-block d-sm-inline-block"
                                target="_blank"
                                v-if="datos_online.puede_descargar_entradas"
                            >
                                <span style="text-transform: uppercase">
                                    DESCARGAR PRODUCTOS
                                </span>
                            </a>
                        </b-col>
                        <b-col cols="12" class="mt-3 px-0 px-sm-2">
                            <TarjetaProducto
                                v-for="(producto, i) in productos"
                                v-bind:key="i"
                                :producto="producto"
                                :index="i"
                            />
                        </b-col>
                    </b-row>
                </template>
            </div>
            <div class="mt-3 px-2" v-if="datos_online.puede_descargar_entradas">
                <template v-if="!es_dia_abonado">
                    <p>
                        <b>
                            {{ $t(
                                datos_online.qr_codes.length > 0 
                                    ? (!reserva_instalaciones ? "gracias.duda_incidencia" : "gracias.duda_incidencia_reservas") 
                                    : "gracias.duda_incidencia_productos", 
                                { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }
                            ) }}
                        </b>
                    </p>
                </template>
                <template v-else>
                    <h1 class="h3 h2-md">
                        {{ $t("gracias.abono_activado") }}
                    </h1>
                    <b>{{ $t("gracias.recuerda") }}</b>
                    <ul class="pl-3 pl-md-4">
                        <li class="mb-2">
                            {{ $t("gracias.una_entrada", {abonado: teatro.texto_abonado}) }}
                        </li>
                        <li class="mb-2">
                            {{ $t("gracias.validez_abono", {abono: teatro.texto_abono}) }}
                        </li>
                        <li class="mb-2">
                            {{ $t("gracias.acceso_nominativo", {abono: teatro.texto_abono}) }}
                        </li>
                        <li class="mb-2">
                            {{ $t("gracias.abono_personal", {abono: teatro.texto_abono}) }}
                        </li>
                        <li class="mb-2">
                            {{ $t("gracias.acceso") }}
                        </li>
                    </ul>
                    <p>
                        {{ $t("gracias.cuestion", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                    </p>
                </template>
            </div>

            <div class="mt-3 px-2" v-if="! datos_online.puede_descargar_entradas">
                <p>Gracias por confiar en <b>Compralaentrada</b>. Tu transacción ha sido procesada con éxito.</p>
                <p class="mt-3"><b>¿Qué sucede ahora?</b></p>
                <ul class="pl-3 pl-md-4">
                    <li class="mb-2">Te hemos enviado un justificante de compra a tu correo electrónico con todos los detalles de tu compra.</li>
                    <li class="mb-2"><b>Tus entradas serán enviadas 72 horas antes del evento</b>, por motivos de seguridad. No te preocupes, ¡todo está en orden!</li>
                    <li class="mb-2">Si seleccionaste la opción de recibir las entradas por <b>WhatsApp</b>, también las recibirás en ese medio dentro del mismo plazo.</li>
                </ul>
                <p class="mt-3">
                    Recuerda revisar tu bandeja de entrada y, en caso de que no las encuentres, no olvides verificar la carpeta de spam o correo no deseado.
                </p>
                <p class="mt-3">
                    <b>Si tienes alguna pregunta o necesitas ayuda</b>, no dudes en ponerte en contacto con nosotros. ¡Estamos aquí para ayudarte!
                </p>
                <p class="mt-3">
                    ¡Nos vemos en el evento!
                </p>
                <p class="mt-3">
                    El equipo de <b>Compralaentrada</b>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import TarjetaEntrada from "./components/TarjetaEntrada.vue";
    import TarjetaProducto from "./components/TarjetaProducto.vue";

    export default {
        props: {
            tpv_order: {
                required: true,
                type: String
            },
            datos_online: {
                required: true,
                type: Object
            },
            datos_compradores: {
                type: Array,
                required: true
            },
            productos: {
                type: Array
            },
            es_dia_abonado: {
                required: true,
                type: Boolean
            },
            evento_id: {
                required: true,
                type: Number
            },
            evento_name: {
                required: true,
                type: String
            },
            total: {
                required: true,
                type: Number
            },
            url_evento: {
                required: true,
                type: String
            },
            user_id: {
                required: true,
                type: Number
            },
            datos_peticion: {
                required: true,
                type: Object
            },
            sesion_fecha: {
                required: true,
                type: String
            },
            reserva_instalaciones: {
                type: [Boolean, Number],
                default: false
            }
        },
        data() {
            return {
                pixel_id: process.env.VUE_APP_PIXEL_ID,
                api_base: process.env.VUE_APP_API_BASE,
            }
        },
        methods: {
            getUrlPdfProducts(qr_code) {
                return this.api_base + '/f/partidos/productos/pdf?tid=' + this.configuracion.hash_teatro + '&qr_code=' + qr_code;
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        components: {
            TarjetaEntrada, TarjetaProducto
        }
    }
</script>